import { shrink } from "./image";

/** Mirrors the API caps (media.service.ts). */
export const MAX_VIDEO_BYTES = 500 * 1024 * 1024;
export const MAX_IMAGE_BYTES = 25 * 1024 * 1024;

export const isVideo = (mime?: string | null) => Boolean(mime && mime.startsWith("video/"));

export class MediaTooLarge extends Error {
  constructor(readonly file: File) {
    super(`${file.name} is larger than ${Math.round(MAX_VIDEO_BYTES / 1024 / 1024)} MB`);
  }
}

/**
 * What goes on the wire for one picked file: photos are re-encoded in the
 * browser (smaller, EXIF stripped, HEIC → JPEG); videos go as recorded, within
 * the cap, since the browser cannot transcode them.
 */
export async function prepareUpload(file: File): Promise<{ body: Blob; filename: string }> {
  if (isVideo(file.type)) {
    if (file.size > MAX_VIDEO_BYTES) throw new MediaTooLarge(file);
    return { body: file, filename: file.name || "video.mp4" };
  }
  const body = await shrink(file).catch(() => file as Blob);
  return { body, filename: body === file ? file.name : file.name.replace(/\.[a-z0-9]+$/i, "") + ".jpg" };
}

export const captionOf = (file: File) => file.name.replace(/\.[a-z0-9]+$/i, "").slice(0, 80);
